import { Injectable } from '@angular/core';
import { HandlerService } from '../comunicator-native/handler/handler';
import { UserNewDataService } from './usernew-data.service';

@Injectable({
  providedIn: 'root'
})
export class UserNewDataMobileService implements UserNewDataService{

  constructor(private handlerService: HandlerService) {}

  public postUserNew(): Promise<any> {
    const relCaronte = 'user-new';
    const params = {};

    return this.handlerService.caronteCommunicator(relCaronte, params, null, true).then((data: any) => {
      if (data) {
        return Promise.resolve(data);
      } else {
        return Promise.reject(data);
      }
    });
  }
}

